import React, { useState, useEffect } from 'react';
import { LayoutContext } from '../types/translations';
import { Outlet } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import en from '../lang/en.json';
import fr from '../lang/fr.json';

const languages = { en, fr };

const Layout: React.FC = () => {
  const [isDark, setIsDark] = useState(false);
  const [language, setLanguage] = useState<'en' | 'fr'>('en');
  const [texts, setTexts] = useState<LayoutContext['texts']>(languages[language]);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  useEffect(() => {
    setTexts(languages[language]);
  }, [language]);

  const toggleTheme = () => setIsDark((prev) => !prev);
  const toggleLanguage = () => setLanguage((prev) => (prev === 'en' ? 'fr' : 'en'));

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#1a1a1a] text-gray-900 dark:text-white transition-colors duration-200">
      <Header isDark={isDark} toggleTheme={toggleTheme} language={language} toggleLanguage={toggleLanguage} texts={texts} />
      <Outlet context={{ isDark, language, toggleTheme, toggleLanguage, texts }} />
      <Footer texts={texts} />
    </div>
  );
};

export default Layout;
